import { Component, OnInit, ChangeDetectorRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { LogService, NotificationService, ListingService, DateService, ArrayService, AppSettingsService, UserService, ValueService } from '@app/services';
import { BookingService } from '@app/listing/services/booking.service';

@Component({
    selector: 'image-with-caption',
    templateUrl: './image-with-caption.component.html',
    styleUrls: ['./image-with-caption.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class ImageWithCaptionComponent implements OnInit {

  @Input()
  public caption:string = 'A west fasts outside the conference.';

  constructor(    private log: LogService,
    private notify: NotificationService,
    private listingService: ListingService,
    private dateService: DateService,
    private valueService: ValueService,
    private arrayService: ArrayService,
    private appSettings: AppSettingsService,
    private userService: UserService,
    private bookingService: BookingService,
    private changeDetector: ChangeDetectorRef) { }

  ngOnInit() {
  }

}
